<div class="delete-wallet-confirmation-container">
  <div class="delete-wallet-confirmation-content">
    <!-- Warning Content -->
    <div class="warning-content">
      <h2 class="warning-title">
        Are you sure you want to delete your wallet?
      </h2>
      <div class="warning-message">
        <p class="warning-text">
          You are about to delete your wallet. Please make sure you have
          exported your wallet or saved your wallets separately before deleting.
        </p>
        <div class="warning-highlight">
          <kc-icon
            iconClass="icon-info"
            size="sm"
            color="var(--warning-color, #FFB800)"
          />
          <span class="highlight-text">
            Without your seed phrase or backup, you will permanently lose access
            to your funds.
          </span>
        </div>
      </div>
    </div>

    <!-- Confirmation Input -->
    <div class="confirmation-section">
      <p class="confirmation-instructions">
        Type <strong>{{ deleteConfirmationPhrase }}</strong> to confirm.
      </p>
      <kc-input
        class="confirmation-input"
        [placeholder]="deleteConfirmationPhrase"
        [ngModel]="deleteConfirmationInput()"
        (valueChange)="onDeleteConfirmationChange($any($event))"
      />
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <kc-button
        [text]="'Cancel'"
        variant="secondary"
        size="m"
        [isFullWidth]="true"
        (buttonClick)="onCancel()"
        class="cancel-button"
      />

      <kc-button
        class="kc-button-danger"
        [text]="'Delete Wallet'"
        variant="secondary"
        size="m"
        [isFullWidth]="true"
        [isDisabled]="!isDeleteConfirmationValid()"
        (buttonClick)="onDeleteWallet()"
        class="delete-wallet-button"
      />
    </div>
  </div>
</div>
